import "./ListaPedidos.css";

export default function ListaPedidos({
  pedidos,
  moeda,
  formatarData,
  abrirItens,
}) {

  if (pedidos.length === 0) {
    return (
      <div className="listapedidos-card">
        Nenhum pedido em aberto.
      </div>
    );
  }

  return (
    <div className="listapedidos-card">

      <table className="listapedidos-table">

        <thead>

          <tr>

            <th>Pedido</th>

            <th>Data Entrega</th>

            <th>Valor</th>

          </tr>

        </thead>

        <tbody>

          {pedidos.map((pedido) => (

            <tr
              key={pedido.nropedido}
              className={
                pedido.tipoped === 4
                  ? "listapedidos-site"
                  : ""
              }
              onClick={() =>
                abrirItens(
                  `Pedido ${pedido.nropedido}`,
                  pedido.itens,
                  "pedido"
                )
              }
            >

              <td>

                {pedido.nropedido}

              </td>

              <td>

                {formatarData(
                  pedido.dtfatura
                )}

              </td>

              <td>

                {moeda(
                  pedido.valorpedido
                )}

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}